import { render, staticRenderFns } from "./basicTab.vue?vue&type=template&id=09fafe9a&"
import script from "./basicTab.vue?vue&type=script&lang=js&"
export * from "./basicTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09fafe9a')) {
      api.createRecord('09fafe9a', component.options)
    } else {
      api.reload('09fafe9a', component.options)
    }
    module.hot.accept("./basicTab.vue?vue&type=template&id=09fafe9a&", function () {
      api.rerender('09fafe9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/salesQuery/tabs/basicTab.vue"
export default component.exports